import { enrichConvertersRegistry } from '../utils/convertersRegistry'
import { atomicStylePropsConverterMap } from './atomicPropsToCss'

/**
 * Enriches the converters registry with all atomic style property converters.
 * Atomic converters handle simple, single-value properties like numbers, keywords, lengths, etc.
 */
export function enrichAtomicConverters(): void {
	// Register all atomic converters
	Object.entries(atomicStylePropsConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
